import { ClassList } from "./ClassList";

export const enum Dimension
{
    Auto,
    D0,
    D5,
    D10,
    D12,
    D14,
    D20,
    D24,
    D30,
    D32,
    D34,
    D40,
    D44,
    D45,
    D50,
    D54,
    D60,
    D65,
    D64,
    D70,
    D74,
    D80,
    D84,
    D86,
    D90,
    D100,
    D104,
    D106,
    D108,
    D118,
    D120,
    D124,
    D126,
    D150,
    D156,
    D160,
    D164,
    D168,
    D332,
    D336,
    D448,
    D458,
    D500,
    D512,
    D532,
    D544,
    D560,
    D590,
    D600,
    D612,
    D624,
    D684,
}

export const dimensionClassMap: Record<Dimension, string> = {
    [Dimension.Auto]: "auto",
    [Dimension.D0]: "0",
    [Dimension.D5]: "5",
    [Dimension.D10]: "10",
    [Dimension.D12]: "12",
    [Dimension.D14]: "14",
    [Dimension.D20]: "20",
    [Dimension.D24]: "24",
    [Dimension.D30]: "30",
    [Dimension.D32]: "32",
    [Dimension.D34]: "34",
    [Dimension.D40]: "40",
    [Dimension.D44]: "44",
    [Dimension.D45]: "45",
    [Dimension.D50]: "50",
    [Dimension.D54]: "54",
    [Dimension.D60]: "60",
    [Dimension.D64]: "64",
    [Dimension.D65]: "65",
    [Dimension.D70]: "70",
    [Dimension.D74]: "74",
    [Dimension.D80]: "80",
    [Dimension.D84]: "84",
    [Dimension.D86]: "86",
    [Dimension.D90]: "90",
    [Dimension.D100]: "100",
    [Dimension.D104]: "104",
    [Dimension.D106]: "106",
    [Dimension.D108]: "108",
    [Dimension.D118]: "118",
    [Dimension.D120]: "120",
    [Dimension.D124]: "124",
    [Dimension.D126]: "126",
    [Dimension.D150]: "150",
    [Dimension.D156]: "156",
    [Dimension.D160]: "160",
    [Dimension.D164]: "164",
    [Dimension.D168]: "168",
    [Dimension.D332]: "332",
    [Dimension.D336]: "336",
    [Dimension.D448]: "448",
    [Dimension.D458]: "458",
    [Dimension.D500]: "500",
    [Dimension.D512]: "512",
    [Dimension.D532]: "532",
    [Dimension.D544]: "544",
    [Dimension.D560]: "560",
    [Dimension.D590]: "590",
    [Dimension.D600]: "600",
    [Dimension.D612]: "612",
    [Dimension.D624]: "624",
    [Dimension.D684]: "684",
};

export interface PlaneDimensions<D>
{
    all?: D;
    bottom?: D;
    left?: D;
    right?: D;
    top?: D;
    x?: D;
    y?: D;
}

export const planeDimensionsClass = <D extends number>(dimensions: PlaneDimensions<D> | undefined, onClass: (side: string, dimension: D | undefined) => string | undefined): ClassList =>
{
    if (dimensions === undefined)
    {
        return [];
    }

    const { all, bottom, left, right, top, x, y } = dimensions;

    const leftValue = left ?? x ?? all;
    const rightValue = right ?? x ?? all;
    const topValue = top ?? y ?? all;
    const bottomValue = bottom ?? y ?? all;

    const xEquals = leftValue === rightValue;
    const yEquals = topValue === bottomValue;

    if (xEquals && yEquals && leftValue === topValue)
    {
        return [
            onClass("", leftValue)
        ];
    }

    const classList: ClassList = [];

    const addClass = (side: string, value: D | undefined) =>
    {
        const c = onClass(side, value);

        if (c !== undefined)
        {
            classList.push(c);
        }
    }

    if (xEquals)
    {
        addClass("x", leftValue);
    }
    else
    {
        addClass("l", leftValue);
        addClass("r", rightValue);
    }

    if (yEquals)
    {
        addClass("y", topValue);
    }
    else
    {
        addClass("t", topValue);
        addClass("b", bottomValue);
    }

    return classList;
}
